import { useEffect } from "react";
import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import CallbackForm from "./CallbackForm";

const CALENDLY_URL =
  "https://calendly.com/abrie-littlesplashswimpro/four-seasons-residents-lssp-trial-lesson-booking?hide_gdpr_banner=1&primary_color=c97049";

export default function BookTrial() {
  useEffect(() => {
    if (!document.querySelector('script[src*="assets.calendly.com"]')) {
      const s = document.createElement("script");
      s.src = "https://assets.calendly.com/assets/external/widget.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <section id="book-trial" data-testid="book-trial-section" className="scroll-mt-24 bg-[#f8f3e9]">
      <div className="mx-auto max-w-4xl px-4 sm:px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase text-[#c97049]">
            <CalendarCheck className="h-4 w-4" />
            Free for Four Seasons residents
          </p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-[#00334a]">
            Your free trial is one click away
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base sm:text-lg text-[#00334a]/70 leading-relaxed">
            Pick any time that works for your family — the calendar is live and booking
            takes less than a minute.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-10 overflow-hidden rounded-[2rem] bg-white border border-[#00334a]/10 shadow-2xl shadow-[#00334a]/15"
        >
          <div
            className="calendly-inline-widget w-full"
            data-url={CALENDLY_URL}
            style={{ minWidth: 320, height: 680 }}
            data-testid="calendly-embed"
          />
        </motion.div>
        <CallbackForm />
      </div>
    </section>
  );
}
